import React from "react";
import { Drawer, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./StandardDrawer.css";

export function StandardDrawerHeader({
  eyebrow,
  title,
  subtitle,
  onClose,
  className = "",
}) {
  return (
    <header className={`standard-drawer-header ${className}`.trim()}>
      <div className="standard-drawer-heading">
        {eyebrow && <div className="standard-drawer-eyebrow">{eyebrow}</div>}
        <h2 className="standard-drawer-title">{title}</h2>
        {subtitle && <p className="standard-drawer-subtitle">{subtitle}</p>}
      </div>
      <IconButton
        className="standard-drawer-close-button"
        onClick={onClose}
        aria-label="Close drawer"
      >
        <CloseIcon />
      </IconButton>
    </header>
  );
}

export function StandardDrawerFooter({ children, className = "" }) {
  return (
    <footer className={`standard-drawer-footer ${className}`.trim()}>
      {children}
    </footer>
  );
}

function StandardDrawer({
  open,
  onClose,
  children,
  className = "",
  contentClassName = "",
  PaperProps = {},
  ...drawerProps
}) {
  const handleDrawerClose = (event, reason) => {
    event?.stopPropagation?.();
    onClose?.(event, reason);
  };

  const paperClassName = ["standard-drawer-paper", className]
    .filter(Boolean)
    .join(" ");
  const contentClassNames = ["standard-drawer-content", contentClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleDrawerClose}
      {...drawerProps}
      PaperProps={{
        ...PaperProps,
        className: [paperClassName, PaperProps.className]
          .filter(Boolean)
          .join(" "),
      }}
    >
      <div
        className={contentClassNames}
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
      >
        {children}
      </div>
    </Drawer>
  );
}

export default StandardDrawer;
